import React from 'react';
import { AlertTriangle, House, RefreshCw } from 'lucide-react';
import type { AppLanguage } from './user-errors';

type Props = { lang: AppLanguage; children: React.ReactNode };
type State = { failed: boolean };

export class PageErrorBoundary extends React.Component<Props, State> {
  state: State = { failed: false };

  static getDerivedStateFromError(): State {
    return { failed: true };
  }

  componentDidCatch(error: unknown) {
    // Keep technical detail in the browser console for developers, never in user-facing copy.
    console.error('Munshi-Gee page error', error);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    const ur = this.props.lang === 'ur';
    return <main className="page-failure" dir={ur ? 'rtl' : 'ltr'}>
      <div>
        <span><AlertTriangle aria-hidden="true" /></span>
        <h1>{ur ? 'یہ صفحہ ابھی نہیں کھل سکا' : 'This page could not open'}</h1>
        <p>{ur ? 'آپ کی محفوظ معلومات متاثر نہیں ہوئی ہیں۔ صفحہ دوبارہ لوڈ کریں، یا ہوم پیج پر واپس جائیں۔' : 'Your saved information has not been affected. Reload the page, or return to the home page.'}</p>
        <nav>
          <button type="button" className="button" onClick={() => window.location.reload()}><RefreshCw />{ur ? 'صفحہ دوبارہ لوڈ کریں' : 'Reload page'}</button>
          <a className="button secondary" href="/app/"><House />{ur ? 'ہوم پیج' : 'Go home'}</a>
        </nav>
      </div>
    </main>;
  }
}
